import React, { useContext } from 'react';
import { ConfigContext } from '../../context/Config';
import Button from '../Button';
import './PracticeActions.less';

export type PracticeActionsProps = {
  trainingLink?: string;
  practiceLink?: string;
};

const PracticeActions: React.FC<PracticeActionsProps> = ({ trainingLink }) => {
  const { translate } = useContext(ConfigContext);

  const handleClick = (event) => event.stopPropagation();

  return (
    <div className="e-button-wrapper">
      {!!trainingLink && (
        <Button href={trainingLink} target="_blank" onClick={handleClick}>
          {translate('ui.join')}
        </Button>
      )}
    </div>
  );
};

export default PracticeActions;
